module.exports = __webpack_public_path__ + "static/media/email-otp-authenticator-logo.9da8e570.png";